import axios from 'axios'
import getConfig from '../config'
import configureResponseInterceptors from './configureResponseInterceptors'
import configureRequestInterceptors from './configureRequestInterceptors'

export const API = axios.create({
    baseURL: getConfig().apiBaseUrl,
    withCredentials: true,
})

const applyGlobalAxiosInterceptors = (axiosInstance = axios) => {
    // axiosRetry(axiosInstance, {
    //     //axiosRetry should always be on the beginning here, otherwise - it may not work
    //     retries: 3,
    //     shouldResetTimeout: true,
    //     retryCondition: error => {
    //         return (
    //             error?.response?.status?.toString().split('')[0] !== '4' &&
    //             error?.response?.status?.toString() !== '500' &&
    //             error?.response?.status?.toString() !== '503'
    //         ) //do not retry 4xx, 500 and 503
    //     }, //By default, axios-retry does not retry timed out requests (i.e. those with ECONNABORTED code) and non-idempotent requests like POST. Set a custom retryCondition to retry no matter what.
    //     retryDelay: axiosRetry.exponentialDelay,
    // })
    configureRequestInterceptors(axiosInstance)
    configureResponseInterceptors(axiosInstance)
}

export default applyGlobalAxiosInterceptors
